module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "left-1"
  }, [_vm._v("“"), _c('i', [_vm._v("A shudder in the loins engenders there"), _c('br'), _vm._v("The broken wall, the burning roof and tower"), _c('br'), _vm._v("And Agamemnon dead.")]), _vm._v("”")]), _vm._v(" "), _c('p', {
    staticClass: "right"
  }, [_c('span', [_c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("WILLIAM BUTLER YEATS")])])]), _vm._v(" "), _c('p', {
    staticClass: "left-1"
  }, [_vm._v("“"), _c('i', [_vm._v("Over us looms atrocious history.")]), _vm._v("”")]), _vm._v(" "), _c('p', {
    staticClass: "right"
  }, [_c('span', [_c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("JORGE LUIS BORGES")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-495aa1af","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/frantmatter01.vue
// module id = 72
// module chunks = 0